import React from 'react';
import { Link } from 'react-router-dom';
import { useAOS } from '../../hooks/useExternalLibs';
import { useLanguage } from '../../contexts/LanguageContext';

const TechnicalSupport = () => {
  // Initialize external libraries using custom hooks
  useAOS();
  
  // Get translation function
  const { t } = useLanguage();

  return (
    <div className="service-details-page">
      {/* Page Title */}
      <div className="page-title dark-background" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/Photo-Building/eid1.JPG)` }}>
        <div className="container position-relative">
          <h1>{t('technicalSupport.pageTitle')}</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">{t('technicalSupport.breadcrumbHome')}</Link></li>
              <li><Link to="/">{t('technicalSupport.breadcrumbServices')}</Link></li>
              <li className="current">{t('technicalSupport.breadcrumbCurrent')}</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details Section */}
      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/services/custom-manufacturing">{t('technicalSupport.customManufacturing')}</Link>
                <Link to="/services/technical-support" className="active">{t('technicalSupport.technicalSupport')}</Link>
                <Link to="/services/after-sales-service">{t('technicalSupport.afterSalesService')}</Link>
                <Link to="/services/quality-assurance">{t('technicalSupport.qualityAssurance')}</Link>
                <Link to="/services/research-development">{t('technicalSupport.researchDevelopment')}</Link>
                <Link to="/services/global-supply-chain">{t('technicalSupport.globalSupplyChain')}</Link>
              </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <div className="service-content text-center">
                <img src={`${process.env.PUBLIC_URL}/assets/img/building/building-ekk.png`} alt="Technical Support" className="img-fluid services-img mx-auto d-block" />
                <h3 className="text-center">{t('technicalSupport.title')}</h3>
                <p className="text-center">
                  {t('technicalSupport.description1')}
                </p>
                <p className="text-center">
                  {t('technicalSupport.description2')}
                </p>
                <h4 className="text-center">{t('technicalSupport.servicesTitle')}</h4>
                <ul className="text-start">
                  {t('technicalSupport.services').map((service, index) => (
                    <li key={index}><i className="bi bi-check-circle"></i> <span>{service}</span></li>
                  ))}
                </ul>
                
                <h4 className="text-center">{t('technicalSupport.specializedTitle')}</h4>
                <p className="text-center">
                  {t('technicalSupport.specializedDescription')}
                </p>
                
                <div className="row gy-4 mt-4">
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('technicalSupport.responseTime')}</h5>
                      <p>{t('technicalSupport.responseTimeDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('technicalSupport.technicalExpertise')}</h5>
                      <p>{t('technicalSupport.technicalExpertiseDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('technicalSupport.problemResolution')}</h5>
                      <p>{t('technicalSupport.problemResolutionDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('technicalSupport.globalSupport')}</h5>
                      <p>{t('technicalSupport.globalSupportDesc')}</p>
                    </div>
                  </div>
                </div>
                
                <h4 className="text-center">{t('technicalSupport.processTitle')}</h4>
                <p className="text-center">
                  {t('technicalSupport.processDescription')}
                </p>
                
                <h4 className="text-center">{t('technicalSupport.resourcesTitle')}</h4>
                <p className="text-center">
                  {t('technicalSupport.resourcesDescription')}
                </p>
                
                <div className="text-center">
                  <Link to="/contact" className="btn btn-primary">{t('technicalSupport.contactSupport')}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section id="related-services" className="related-services section">
        <div className="container">
          <div className="section-title" data-aos="fade-up">
            <h2>{t('technicalSupport.relatedServicesTitle')}</h2>
            <p>{t('technicalSupport.relatedServicesDescription')}</p>
          </div>
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-compass-drafting"></i>
                </div>
                <h3>{t('technicalSupport.afterSalesService')}</h3>
                <p>{t('technicalSupport.afterSalesServiceDesc')}</p>
                <Link to="/services/after-sales-service" className="readmore stretched-link">{t('technicalSupport.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-mountain-city"></i>
                </div>
                <h3>{t('technicalSupport.customManufacturing')}</h3>
                <p>{t('technicalSupport.customManufacturingDesc')}</p>
                <Link to="/services/custom-manufacturing" className="readmore stretched-link">{t('technicalSupport.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-trowel-bricks"></i>
                </div>
                <h3>{t('technicalSupport.qualityAssurance')}</h3>
                <p>{t('technicalSupport.qualityAssuranceDesc')}</p>
                <Link to="/services/quality-assurance" className="readmore stretched-link">{t('technicalSupport.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TechnicalSupport;